// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

h2 {
  margin-bottom: 16px;
  margin-top: 40px;
  text-align: left;
}

.wrapper-booking-payment {
  background-color: #F8F9FE;
  margin-bottom: 24px;
  --border: none;
  margin: 0 -30px;
  padding: 30px;
}
.wrapper-booking-payment .facility {
  font-size: 1rem;
  font-family: "Roboto-Medium";
  color: var(--vl-black);
  text-align: left;
}
.wrapper-booking-payment .facility span {
  color: #b5b5bc;
  font-size: 0.9rem;
}
.wrapper-booking-payment .duration {
  font-family: "Roboto-Regular";
  font-size: 0.75rem;
  color: var(--vl-black-font);
  text-align: left;
}
.wrapper-booking-payment .costs {
  text-align: right;
}
.wrapper-booking-payment .costs .text {
  font-family: "Roboto-Regular";
  font-size: 0.75rem;
  color: var(--vl-black-font);
  font-weight: 400;
}
.wrapper-booking-payment .costs .price {
  font-size: 1rem;
  font-family: "Roboto-Medium";
  font-weight: 500;
  color: var(--vl-red);
}
.wrapper-booking-payment .from-to {
  display: flex;
  padding-top: 16px;
}
.wrapper-booking-payment .from-to .from, .wrapper-booking-payment .from-to .to {
  width: 45%;
  padding: 10px;
  border: 1px solid #EDEEF3;
  border-radius: 10px;
}
.wrapper-booking-payment .from-to .from .text, .wrapper-booking-payment .from-to .to .text {
  font-size: 0.75rem;
  text-align: left;
}
.wrapper-booking-payment .from-to .from .date, .wrapper-booking-payment .from-to .to .date {
  font-size: 0.9rem;
  font-family: "Roboto-Regular";
  color: var(--vl-black);
  text-align: left;
}
.wrapper-booking-payment .from-to .arrow {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrapper-booking-payment p {
  margin: 0;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-family: "Roboto-Regular";
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/shared/components/what-to-pay-block/booking-payment-information.component.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;AA0DF;;AAvDA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;AA0DF;AAxDE;EACE,eAAA;EACA,4BDXY;ECYZ,sBAAA;EACA,gBAAA;AA0DJ;AAxDI;EACE,cAAA;EACA,iBAAA;AA0DN;AAtDE;EACE,6BDpBa;ECqBb,kBAAA;EACA,2BAAA;EACA,gBAAA;AAwDJ;AArDE;EACE,iBAAA;AAuDJ;AArDI;EACE,6BD9BW;EC+BX,kBAAA;EACA,2BAAA;EACA,gBAAA;AAuDN;AApDI;EACE,eAAA;EACA,4BDxCU;ECyCV,gBAAA;EACA,oBAAA;AAsDN;AAlDE;EACE,aAAA;EACA,iBAAA;AAoDJ;AAlDI;EACE,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAoDN;AAlDM;EACE,kBAAA;EACA,gBAAA;AAoDR;AAjDM;EACE,iBAAA;EACA,6BD7DS;EC8DT,sBAAA;EACA,gBAAA;AAmDR;AA/CI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAiDN;AA5CE;EACE,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,6BDhFa;ECiFb,gBAAA;AA8CJ","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\nh2 {\n  margin-bottom: 16px;\n  margin-top: 40px;\n  text-align: left;\n}\n\n.wrapper-booking-payment {\n  background-color: #F8F9FE;\n  margin-bottom: 24px;\n  --border: none;\n  margin: 0 -30px;\n  padding: 30px;\n\n  .facility {\n    font-size: 1rem;\n    font-family: $roboto-medium;\n    color: var(--vl-black);\n    text-align: left;\n\n    span {\n      color: #b5b5bc;\n      font-size: 0.9rem;\n    }\n  }\n\n  .duration {\n    font-family: $roboto-regular;\n    font-size: 0.75rem;\n    color: var(--vl-black-font);\n    text-align: left;\n  }\n\n  .costs {\n    text-align: right;\n\n    .text {\n      font-family: $roboto-regular;\n      font-size: 0.75rem;\n      color: var(--vl-black-font);\n      font-weight: 400;\n    }\n\n    .price {\n      font-size: 1rem;\n      font-family: $roboto-medium;\n      font-weight: 500;\n      color: var(--vl-red);\n    }\n  }\n\n  .from-to {\n    display: flex;\n    padding-top: 16px;\n\n    .from, .to {\n      width: 45%;\n      padding: 10px;\n      border: 1px solid #EDEEF3;\n      border-radius: 10px;\n\n      .text {\n        font-size: 0.75rem;\n        text-align: left;\n      }\n\n      .date {\n        font-size: 0.9rem;\n        font-family: $roboto-regular;\n        color: var(--vl-black);\n        text-align: left;\n      }\n    }\n\n    .arrow {\n      width: 10%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n  }\n\n  p {\n    margin: 0;\n    padding: 8px 16px;\n    font-size: 0.9rem;\n    font-family: $roboto-regular;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
